
export default {
    name: 'RiskLevelSelect',
    computed: {
        scoreOptions() {
            return [
                {
                    value: 2,
                    text: this.$t(`fe_contractors['form.revision.enum_lowRisk']`),
                    color: 'green',
                },
                {
                    value: 4,
                    text: this.$t(`fe_contractors['form.revision.enum_mediumRisk']`),
                    color: 'yellow darken-2',
                },
                {
                    value: 6,
                    text: this.$t(`fe_contractors['form.revision.enum_highRisk']`),
                    color: 'red',
                },
                {
                    value: null,
                    text: this.$t(`fe_contractors['form.revision.enum_ignoreQuestion']`),
                    color: 'grey',
                },
            ]
        },
    },
}
